import React from 'react'
import { Avatar } from "primereact/avatar";

const AvatarComponent = ({ label, size, shape, className, style }) => {
  return (<Avatar label={label} size={size} shape={shape} className={className} style={style}/>);
};

export default AvatarComponent;